// extracted by mini-css-extract-plugin
export default {"icon":"style_icon__OXUUW","close":"style_close__0n+7v","clear":"style_clear__Q6nXM","name":"style_name__tn0YG"};